import React, { useEffect, useState } from 'react'

interface ICountDownProps {
  count: number // 秒
  interval?: number // 多少秒刷新一次
  onStop?: () => void
}

export default function CountDown({
  count,
  interval = 1,
  onStop,
}: ICountDownProps) {
  const [current, setCurrent] = useState(count)

  useEffect(() => {
    if (current <= 0) {
      onStop && onStop()
      return
    }

    const timeout = setTimeout(() => setCurrent(current - 1), interval * 1000)

    return () => clearTimeout(timeout)
  }, [current])

  return <span>{current}</span>
}
